/** @jsxImportSource @emotion/react */
import { COLORS } from '@btime/constants'
import { css } from '@emotion/react'
import { omit } from 'ramda'
import React from 'react'

import { useColors } from '../../packages/kiti/components/theme/_hooks/colors'

const Slider = ({ onChange, value, min, max, ...props }) => {
  const colors = useColors()
  const style = css`
    -webkit-appearance: none !important;
    background: ${colors.light3};
    height: 7px;
    border-radius: 7px;
    width: 100%;

    &::-webkit-slider-thumb {
      -webkit-appearance: none !important;
      background: ${colors.dark3};
      height: 14px;
      width: 14px;
      border-radius: 14px;
    }
  `

  return (
    <input
      css={style}
      id="slider"
      className="slider"
      onChange={onChange}
      value={value}
      type="range"
      min={min || '0'}
      max={max || '300'}
      {...omit(['leftPadding', 'leftContent', 'small'], props)}
    />
  )
}

export default Slider
